/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 1/12/2021
 */
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import BaseMultiFormElement from "@/core/modules/coach/Resources/Forms/model/FormElements/General/BaseMultiFormElement";

export default class FormElementCheckboxes extends BaseMultiFormElement {

	checkboxAnswers = []

	constructor(title, isRequired) {
		super(FormElementType.CHECKBOXES, title, isRequired);
	}

	resetElement() {
		super.resetElement();
		this.showScoring = true
		this.enableScoring = true
	}

	_calculateAnswerScoreAsBuckets(formItem){
		let optionsLength = this.answerOptions.length
		let res = new Array(optionsLength).fill(0);
		console.log("FormItem.recalculateScore: this.checkboxAnswers = ", this.checkboxAnswers)
		console.log("FormItem.recalculateScore: this.answerOptionsScoring = ", this.answerOptionsScoring)
		let numberOfAnswersGiven = Object.keys(this.checkboxAnswers).length
		for(let i = 0; i < optionsLength; ++i){
			let answerIndex = this.checkboxAnswers[i]
			if(answerIndex != null){
				let score = this.computeResultScore(this.answerOptionsScoring[answerIndex], numberOfAnswersGiven)
				res[answerIndex] = score
			}
		}
		return res
	}

	_calculateAnswerScoreAsTotal(formItem){
		let score = 0
		this.checkboxAnswers.forEach(answerIndex => {
			score += this.computeResultScore(this.answerOptionsScoring[answerIndex])
		})
		return score
	}

	numberOfAnswers(){
		return this.checkboxAnswers.filter(checkbox => checkbox === true).length
	}


	calculateMaxScore() {
		console.log("FormElementCheckboxes: calculateMaxScore ")
		if(this.answerOptionsScoring.length === 0){
			return 0
		}

		let maxScore = null

		for(let ansNumber = 1; ansNumber <= this.answerOptionsScoring.length; ansNumber++){

			let scoringCalculated = this.answerOptionsScoring.map(scoreFormula => {
				return this.computeResultScore(scoreFormula, ansNumber)
			})

			console.log("FormElementCheckboxes: scoringCalculated = ", scoringCalculated)

			//sort array in descending order, take first ansNumber elements, sum them to get the local max score
			let localMax = scoringCalculated.sort((a, b) => b - a).slice(0, ansNumber).reduce((sum, a) => sum + a, 0)

			if(maxScore === null){
				maxScore = localMax
			} else if(localMax > maxScore){
				maxScore = localMax
			}
			console.log("FormElementCheckboxes: localMax = ", localMax, ", maxScore = ", maxScore)

		}

		return maxScore
	}

	checkboxAnswersFormatted(){
		let answers = []
		this.checkboxAnswers.forEach(answerIndex => {

			if(answerIndex >= this.answerOptions.length){
				if(this.otherAnswer){
					answers.push(this.otherAnswer)
				}
			} else {
				answers.push(this.answerOptions[answerIndex])
			}
		})
		return answers.join(", ")
	}

}
